
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"21","viewBox":"0 0 15 21","fill":"white","stroke":"white","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.08591 0.965926C5.22885 0.43246 5.77719 0.115877 6.31065 0.258819L8.2425 0.776457C8.77597 0.919399 9.09255 1.46774 8.94961 2.0012L8.69079 2.96713L4.82709 1.93185L5.08591 0.965926Z","stroke":"none"}}),_c('path',{attrs:{"d":"M0.258759 1.671C0.401701 1.13754 0.950038 0.820955 1.4835 0.963897L13.0746 4.06973C13.6081 4.21267 13.9247 4.761 13.7817 5.29447L13.5229 6.2604L-5.99623e-05 2.63693L0.258759 1.671Z","stroke":"none"}}),_c('path',{attrs:{"d":"M2 6V19C2 19.5523 2.44772 20 3 20H11C11.5523 20 12 19.5523 12 19V6","fill":"none","stroke-width":"2"}})])
          )
        }
      }
    